import {createStore} from 'ice';
import homeStore from './model';

const store = createStore({default: homeStore});

export default store;
